<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @handleSearchJsf="handleSearchJsf"
      @handleSearchCst="handleSearchCst" @search="search">
      <template slot="btns" v-if="btns.indexOf('review') > -1">
        <a-button @click="showModal(1)" :loading="checkLoad" class="search-btn-item" type="primary"
          :disabled="!selectedRowKeys.length">同意</a-button>
        <a-button @click="showModal(2)" :loading="checkLoadCancel" class="search-btn-item btn-blue-line"
          :disabled="!selectedRowKeys.length">拒绝</a-button>
          
      </template>
      <template slot="btns" v-if="btns.indexOf('export') > -1">
        <a-button @click="onExport" class="search-btn-item" type="primary">导出</a-button>
      </template>
    </search-form>

    <div class="table-common common-scroll">
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        支付金额：
        <span class="text-color-orange">{{ totalPayable(selectedRows, "payAmount") | splitK }} 元</span>
      </div>
      <a-table size="middle" :columns="columns" :data-source="tableData" :pagination="pagination" :loading="loading"
        :row-key="(record, index) => record.id" @change="handleTableChange" bordered :locale="{ emptyText: '暂无数据' }"
        :row-selection="btns.length > 0 ? tableSelect : null" :scroll="{}">
        <template slot="guarantorName" slot-scope="text,record">
          <span v-if="record.guarantorName">
            {{ record.guarantorName }}
          </span>
          <span v-else>--</span>
        </template>
        <template slot="holderName" slot-scope="text, record">
          <span :title="record.holderName || record.rcPtyName">{{
            record.holderName || record.rcPtyName
          }}</span>
        </template>
        <template slot="gldAmount" slot-scope="text, record">{{
          record.gldAmount | splitK
        }}</template>
        <template slot="toRepyAmt" slot-scope="text, record">
          {{
            totaltoRepyGldInt(record)
              ? totaltoRepyAmt(record) + "+" + totaltoRepyGldInt(record)
              : totaltoRepyAmt(record)
          }}
        </template>
        <template slot="payAmount" slot-scope="text">{{
          text | splitK
        }}</template>
        <template slot="exDate" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="createTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="canBeModified" slot-scope="text">
          {{ text | gbCbmTrans }}
        </template>
        <template slot="residueDays" slot-scope="text, record">
          {{ getDaysFormNow(record.exDate) }}
        </template>
        <template slot="status" slot-scope="text">
          {{ text | dictFilter(statusList) }}
        </template>
        <template slot="odueCd" slot-scope="text">
          {{ text == 1 ? "是" : "否" }}
        </template>
        <template slot="openType" slot-scope="text,record">
          <div class="spaceCenter">
            <div v-if="record.openType">
              <span v-if="record.openType == 0">无</span>
              <span v-if="record.openType == 1">有</span>
            </div>
            <span v-else>--</span>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-if="record.isNotice == 1" @click="toPayNotice(record)">
            付款通知
          </a>
          <a @click="uploadVoucher(record, 'detail')">
            查看凭证
          </a>
        </template>
      </a-table>
      <!-- <div
        :class="{
          'table-total': pagination.total > 0,
          'table-total-none': pagination.total == 0
        }"
      >
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>祺信面额：
        <span class="text-color-orange"
          >{{ totalPayable(tableData) | splitK }} 元</span
        >
      </div> -->
    </div>

    <payNotice ref="payNotice" :info.sync="curItem" />
    <uploadVoucherDialog ref="uploadVoucherDialog" @success="refresh" />
    <cashingPasswordModal ref="cashingPasswordModal" @success="refresh" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { reviewPayVoucherList, handelUserList ,reviewPayVoucherListExport} from "@/api/review.js";
import { findGoldEstbOrRcPtyOrPypt } from "@/api/gold.js";
import { isShowPymNoticeFile } from "@/api/buyrPym.js";
import cashingPasswordModal from "@/pages/review/cashing/cashing-password-modal";
import payNotice from "@/pages/bill-payment/pay-notice";
import uploadVoucherDialog from "@/pages/bill-payment/uploadVoucherDialog.vue";
export default {
  props: {
    tabType: {
      type: [String],
      required: false,
      default: function () {
        return ""; //所属tab的分类
      }
    },
    status: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      }
    },
    btns: {
      type: [Array],
      required: false,
      default: function () {
        return [];
      }
    },
    cols: {
      type: Array
    }
  },
  components: {
    cashingPasswordModal,
    payNotice,
    uploadVoucherDialog
  },
  data() {
    return {
      searchData: {
        applyDate: [],
        gldId: "",
        estb: {},
        receiver: {},
        exDate: [],
        canBeModified: [],
        tenantId: {},
        manager: {},
        status: "",
        userName: undefined,
        odueCd: undefined
      },
      formConfig: [
        {
          prop: "gldId",
          type: "input",
          label: "祺信编号"
        },
        {
          prop: "applyDate",
          type: "dateRange",
          label: "申请日期",
          hidden: ["review", "records"].indexOf(this.tabType) == -1
        },
        {
          prop: "receiver",
          type: "selectSearch",
          label: "接收方",
          option: [],
          searchSource: true,
          headNameFirst: "接收方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchJsf"
        },
        {
          prop: "canBeModified",
          type: "select",
          label: "变更状态",
          option: this.dict.modifiedStatus,
          mode: 'multiple',
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "userName",
          type: "select",
          label: "经办员",
          option: [],
          defaultProps: {
            value: "handleUserNum", //handleUserNum
            label: "userName"
          },
          hidden: ["review", "records"].indexOf(this.tabType) == -1
        },
        {
          prop: "odueCd",
          type: "select",
          label: "是否逾期",
          option: this.dict.yesOrNo,
          defaultProps: {
            value: "value",
            label: "name"
          },
          hidden: ["review", "records"].indexOf(this.tabType) > -1
        },
        {
          prop: "exDate",
          type: "dateRange",
          label: "到期日期"
        }

        // {
        //   prop: "status",
        //   type: "select",
        //   label: "状态",
        //   hide: this.tabType == "review",
        //   option: [
        //     { name: "已同意", value: "1" },
        //     { name: "已拒绝", value: "2" }
        //   ],
        //   defaultProps: {
        //     value: "value",
        //     label: "name"
        //   }
        // }
      ],
      columns: [
        {
          title: "申请日期",
          sorter: true,
          dataIndex: "createTime",
          width: 100,
          scopedSlots: { customRender: "createTime" }
        },
        {
          title: "祺信编号",
          dataIndex: "gldId",
          width: 180,
          ellipsis: true,
          sorter: true
        },
        {
          title: "担保方",
          dataIndex: "guarantorName",
          scopedSlots: { customRender: "guarantorName" },
        },
        {
          title: "接收方",
          dataIndex: "rcPtyName",
          width: 180,
          ellipsis: true,
          sorter: true
        },
        {
          title: "持有方",
          dataIndex: "holderName",
          scopedSlots: { customRender: "holderName" },
          ellipsis: true,
          width: 180
        },
        {
          title: "祺信面额(元)",
          dataIndex: "gldAmount",
          scopedSlots: { customRender: "gldAmount" },
          width: 160
        },
        // {
        //   title: "待付余额(元)",
        //   dataIndex: "toRepyAmt",
        //   sorter: true,
        //   width: 100,
        //   scopedSlots: { customRender: "toRepyAmt" }
        // },
        {
          title: "付款金额(元)",
          dataIndex: "payAmount",
          sorter: true,
          width: 140,
          scopedSlots: { customRender: "payAmount" }
        },
        {
          title: "到期日期",
          sorter: true,
          dataIndex: "exDate",
          width: 100,
          scopedSlots: { customRender: "exDate" }
        },
        {
          title: "剩余天数",
          width: 100,
          dataIndex: "residueDays",
          scopedSlots: { customRender: "residueDays" }
        },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          width: 100,
          scopedSlots: { customRender: "canBeModified" }
        },
        {
          title: "经办员",
          dataIndex: "userName",
          width: 100
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 100,
          scopedSlots: { customRender: "status" }
        },
        {
          title: "是否逾期",
          dataIndex: "odueCd",
          width: 100,
          scopedSlots: { customRender: "odueCd" }
        },
        {
          title: "有无发票",
          dataIndex: "openType",
          width: 80,
          scopedSlots: { customRender: "openType" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: 220,
          scopedSlots: { customRender: "operation" }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "",
        sortOrder: "",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      curItem: {},
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      checkLoad: false,
      checkLoadCancel: false,
      statusList: []
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    }),
    tableSelect() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        onChange: this.onTableChange,
        type: "radio"
      };
    }
  },
  methods: {
      onExport() {
        const params = {
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        status: this.searchData.status || this.status,
        
        estb: this.searchData.estb.key,
        gldId: this.searchData.gldId,
        rcPty: this.searchData.receiver.key,
        applyDateSt: this.searchData.applyDate[0],
        applyDateEd: this.searchData.applyDate[1],
        exDateSt: this.searchData.exDate[0],
        exDateEd: this.searchData.exDate[1],
        canBeModified: (this.searchData.canBeModified && this.searchData.canBeModified.length > 0) ? this.searchData.canBeModified.join(',') : null,
        userName: this.searchData.userName,
        odueCd: this.searchData.odueCd
      };
      reviewPayVoucherListExport(params).then(res => {
        this.utils.fileDownload(res, `查询记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
    toPageDetail(data) {
      let way = "buyer";
      this.MENUAPI.goToOneTab({
        path: "bill-payment/payment/detail/" + way + "/" + data.gldId + "/" + 3,
        query: {
          fromPath: "bill-payment/payment",
          detailFrom:"payment"
        }
      });
    },
    handleSearchJsf(value, data, cfg) {
      let param = {
        queryType: 0
      };
      this.getDataList(value, param, cfg);
    },
    getDataList(value, param = {}, cfg) {
      //下拉筛选
      const cstIds = this.userObj.cstIds.join(",");
      findGoldEstbOrRcPtyOrPypt({
        pageNum: 1,
        pageSize: 10,
        gldStCds: this.gldStCds,
        oriGldId: this.oriGldId,
        estb: cstIds,
        pypt: cstIds,
        queryType: 0,
        cstIds: cstIds
      })
        .then(res => {
          const index = this.formConfig.findIndex(
            item => item.prop == cfg.prop
          );
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSearchCst(value, data, cfg) {
      this.getDataListTenant(value, cfg);
    },
    getDataListTenant(value, cfg) {
      //下拉筛选
      selectTenant({
        tenantName: value,
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1
      })
        .then(res => {
          const index = this.formConfig.findIndex(
            item => item.prop == cfg.prop
          );
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSearchManager() {
      handelUserList()
        .then(res => {
          const index = this.formConfig.findIndex(
            item => item.prop == "userName"
          );
          this.formConfig[index].option = res.data || [];
        })
        .catch(error => {
          console.log(error);
        });
    },
    search(data) {
      this.searchData = data || this.searchData;
      console.log("%c Line:469 🍕 this.searchData", "color:#e41a6a", this.searchData);
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const params = {
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        status: this.searchData.status || this.status,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        estb: this.searchData.estb.key,
        gldId: this.searchData.gldId,
        rcPty: this.searchData.receiver.key,
        applyDateSt: this.searchData.applyDate[0],
        applyDateEd: this.searchData.applyDate[1],
        exDateSt: this.searchData.exDate[0],
        exDateEd: this.searchData.exDate[1],
        canBeModified: (this.searchData.canBeModified && this.searchData.canBeModified.length > 0) ? this.searchData.canBeModified.join(',') : null,
        userName: this.searchData.userName,
        odueCd: this.searchData.odueCd
      };
      reviewPayVoucherList(params)
        .then(res => {
          this.loading = false;
          this.pagination.total = res.data.grid.total;
          this.tableData = res.data.grid.list;
          this.isShowPymNoticeFile();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    isShowPymNoticeFile() {
      const params = [];
      let data = this.tableData;
      if (data.length == 0) {
        return;
      }
      data.forEach(item => {
        params.push({ gldId: item.gldId, tenantId: item.tenantId });
      });
      isShowPymNoticeFile({ gldListStr: JSON.stringify(params) }).then(res => {
        let resData = res.data;
        let list = data.map(i => i.gldId);
        for (let k = 0; k < resData.length; k++) {
          let k_index = list.indexOf(resData[k].gldId);
          if (k_index > -1) {
            this.$set(this.tableData, k_index, {
              ...this.tableData[k_index],
              isNotice: resData[k].isNotice
            });
          }
        }
      });
    },
    totalPayable(list = [], prop = "gldAmount") {
      return list.reduce((acc, rec) => {
        return acc + (+rec[prop] || 0);
      }, 0);
    },
    handleTableChange(pagination, filters, sorter) {
      //表格排序回调
      this.pagination = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        sortField: sorter.field,
        sortOrder: sorter.order,
        total: this.pagination.total || 0
      };
      this.getTableData();
    },
    onTableChange(selectedRows, data, data2) {
      //表格选择回调
      this.selectedRowKeys = selectedRows;
      this.selectedRows = this.tableData.filter(
        item => selectedRows.indexOf(item.id) > -1
      );
    },
    showModal(type) {
      if (!this.selectedRows.length) {
        this.$message.warn("请至少选择一条数据");
        return;
      }
      this.$refs.cashingPasswordModal.open({
        tableData: this.selectedRows,
        status: type,
        title: "兑付复核-" + (type == 2 ? "拒绝" : "同意")
      });
    },
    // 查看付款通知书
    toPayNotice(data) {
      this.curItem = data;
      this.$refs.payNotice.open();
    },
    // 打开上传凭证的弹窗
    uploadVoucher(record, type) {
      this.$refs.uploadVoucherDialog.open({
        record: record,
        type
      });
    },
    totaltoRepyGldInt(rows) {
      return [rows].reduce((acc, rec) => {
        return this.utils.splitK(acc + (rec.toRepyGldInt || 0));
      }, 0);
    },
    totaltoRepyAmt(rows) {
      return [rows].reduce((acc, rec) => {
        return this.utils.splitK(acc + (rec.toRepyAmt || 0));
      }, 0);
    },
    // 计算距离到期日还有几天
    getDaysFormNow(date) {
      let a = this.moment(window.sessionStorage.getItem("systemDate") || "");
      let b = this.moment(date);
      let res = b.diff(a, 'days');
      if (+res >= 0) {
        return res;
      }
    },
    refresh() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.getTableData();
      this.$store.dispatch("home/getMessageCount");
    },
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    })
  },
  created() {
    this.getDicAsync("RepayVoucherStatus").then(res => {
      this.statusList = res;
    });
    if (this.cols) {
      this.columns = this.columns.filter(i => this.cols.indexOf(i.title) > -1);
    }
    this.getTableData();
    this.handleSearchManager();
  },
  mounted() { },
  activated() { }
};
</script>
<style scoped>
.input-content>div {
  margin: 10px 20px 20px 0;
}

.common /deep/ .search-item-lable {
  min-width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/cashing/cashing-main.vue